module.exports = __webpack_public_path__ + "static/media/shirts10.af4a935c.jpg";